import { request } from "./http";

export interface Organization {
  id: string;
  slug: string;
  name: string;
  plan: string;
  region: string;
  status: string;
  primary_domain: string | null;
  branding: Record<string, unknown>;
}

/** Branding fields the backend `BrandingPatch` schema accepts. */
export interface BrandingPatchBody {
  primary_color?: string | null;
  accent_color?: string | null;
  logo_url?: string | null;
  favicon_url?: string | null;
  company_name?: string | null;
  css_overrides?: string | null;
}

export const organizations = {
  me: () => request<Organization>("/api/v1/organizations/me"),
  patchBranding: (body: BrandingPatchBody) =>
    request<Organization>("/api/v1/organizations/me/branding", {
      method: "PATCH",
      body,
    }),
};
